/**
 * Copy-to-clipboard for the Ask Simply starter prompts.
 *
 * Contract (ask-simply-section.html.twig): a .ask-simply__copy button carrying
 * data-copy-target, plus one [data-copy-status] live region. Delegated from
 * document, so the single init in app.js covers every instance.
 */
export function copyPrompt() {
	function flag(button) {
		button.classList.add('is-copied');
		window.clearTimeout(button._copyTimer);
		button._copyTimer = window.setTimeout(function () {
			button.classList.remove('is-copied');
		}, 2000);

		// Re-set the text so the live region announces again on a repeat copy.
		const status = document.querySelector('[data-copy-status]');
		if (status) {
			status.textContent = '';
			window.setTimeout(function () {
				status.textContent = status.dataset.copyMsg || '';
			}, 30);
		}
	}

	// navigator.clipboard only exists in a secure context, so fall back to a
	// throwaway textarea when the page is served over plain HTTP.
	function copy(text, button) {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(text).then(function () { flag(button); });
			return;
		}

		var scratch = document.createElement('textarea');
		scratch.value = text;
		scratch.setAttribute('readonly', '');
		scratch.style.position = 'absolute';
		scratch.style.left = '-9999px';
		document.body.appendChild(scratch);
		scratch.select();
		try {
			if (document.execCommand('copy')) {
				flag(button);
			}
		} catch (e) {
			// clipboard unavailable; leave the button in its resting state
		}
		document.body.removeChild(scratch);
	}

	document.addEventListener('click', function (event) {
		const button = event.target.closest && event.target.closest('.ask-simply__copy');
		if (!button) {
			return;
		}

		const source = document.querySelector(button.dataset.copyTarget);
		if (source) {
			copy(source.textContent.trim(), button);
		}
	});
}
